// extracted by mini-css-extract-plugin
export default {"layout":"App_layout__UNCUu","notificationContainer":"App_notificationContainer__PsNvl"};